
export type GetProjects200PageAllOfThreeContentItemBasicInfoVisibility = typeof GetProjects200PageAllOfThreeContentItemBasicInfoVisibility[keyof typeof GetProjects200PageAllOfThreeContentItemBasicInfoVisibility];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetProjects200PageAllOfThreeContentItemBasicInfoVisibility = {
  PUBLIC: 'PUBLIC',
  PRIVATE: 'PRIVATE',
  LINK_ONLY: 'LINK_ONLY',
} as const;
